import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// ga4 user_pseudo_id so every component can see it
window.ga4_id =
  (window.dataLayer?.find(o => o.user_pseudo_id) || {}).user_pseudo_id ||
  document.cookie.match(/(?:^|;\s*)_ga=GA1\.\d\.(\d+\.\d+)/)?.[1] || '';

// hydrate hidden field when dom is ready
document.addEventListener('DOMContentLoaded', () => {
  const fld = document.getElementById('ga4_id');
  if (fld) fld.value = window.ga4_id;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// Delayed-load Sentry and PostHog so the SDK chunks stay off the critical
// render path. requestIdleCallback fires after first paint when the browser
// is idle; setTimeout is a fallback for Safari and any browser that
// lacks rIC. Each SDK is dynamic-imported as its own separate chunk and
// initialized in its own idle slot, so neither affects main.js gzipped
// size and their init work never stacks into one long main-thread task.
// PostHog goes second and later: its replay recorder is the heavier init,
// and a lost first pageview costs less than a janky first interaction.
const whenIdle = (fn, timeout, fallbackDelay) => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(fn, { timeout });
  } else {
    setTimeout(fn, fallbackDelay);
  }
};
// PostHog loads on the user's first interaction OR on idle, whichever
// comes first (import-on-interaction). A fast user's first touch starts
// the SDK fetch immediately, shrinking the unrecorded window to the fetch
// itself, while a passive visitor still costs nothing until the browser
// is idle. The listeners are passive and remove themselves on first fire,
// so they never delay the interaction they observe.
let posthogRequested = false;
const loadPostHog = () => {
  if (window.location.pathname === '/r' || /^\/commercial(?:-agreement)?\//.test(window.location.pathname) || posthogRequested) return;
  posthogRequested = true;
  import('./posthog-init').then((m) => m.initPostHog()).catch(() => {});
};
if (typeof window !== 'undefined') {
  const interactionEvents = ['pointerdown', 'keydown', 'touchstart'];
  const onFirstInteraction = () => {
    interactionEvents.forEach((e) =>
      window.removeEventListener(e, onFirstInteraction));
    loadPostHog();
  };
  interactionEvents.forEach((e) =>
    window.addEventListener(e, onFirstInteraction, { passive: true }));
  whenIdle(() => {
    if (window.location.pathname !== '/r' && !/^\/commercial(?:-agreement)?\//.test(window.location.pathname)) {
      import('./sentry-init').then((m) => m.initSentry()).catch(() => {});
    }
    whenIdle(loadPostHog, 10000, 4000);
  }, 5000, 2000);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
